/* eslint-disable @typescript-eslint/no-non-null-assertion */

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';

const container = document.querySelector('.appRoot');
const ROOT = createRoot(container!); // createRoot(container!) if you use TypeScript
ROOT.render(<App />);
